var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"aecb9f41d10b909396c016479bb5f9e58c5c1f45"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["homebase1@homebase"]={id:"aecb9f41d10b909396c016479bb5f9e58c5c1f45"};
      